'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_PrestoRouter$$anon$2() {
  this.bgo = null;
  this.bgm = null;
  this.bgn = false;
  this.bgk = null;
  this.bgl = false;
  this.bgp = false;
  this.bgq = false;
  this.bgo = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
}
export { $c_Lpresto_PrestoRouter$$anon$2 as $c_Lpresto_PrestoRouter$$anon$2 };
$p = $c_Lpresto_PrestoRouter$$anon$2.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_PrestoRouter$$anon$2;
/** @constructor */
function $h_Lpresto_PrestoRouter$$anon$2() {
}
export { $h_Lpresto_PrestoRouter$$anon$2 as $h_Lpresto_PrestoRouter$$anon$2 };
$h_Lpresto_PrestoRouter$$anon$2.prototype = $p;
$p.a1 = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a);
});
$p.af = (function() {
  return this.bgo;
});
$p.t = (function() {
  if ((!this.bgn)) {
    this.bgm = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.bgn = true;
  }
  return this.bgm;
});
$p.ag = (function() {
  if ((!this.bgl)) {
    this.bgk = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.bgl = true;
  }
  return this.bgk;
});
$p.v = (function() {
  if ((!this.bgq)) {
    this.bgp = false;
    this.bgq = true;
  }
  return this.bgp;
});
$p.ae = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredEncoder__encodeProduct__O__Lio_circe_JsonObject(this, a);
});
var $d_Lpresto_PrestoRouter$$anon$2 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_PrestoRouter$$anon$2, "presto.PrestoRouter$$anon$2", ({
  NS: 1,
  a: 1,
  l: 1,
  n: 1,
  o: 1,
  p: 1,
  d: 1
}));
export { $d_Lpresto_PrestoRouter$$anon$2 as $d_Lpresto_PrestoRouter$$anon$2 };
//# sourceMappingURL=presto.-Presto-Router$$anon$2.js.map
